import createTableStore from "ds/components/Table/store/useTableStore";

import {
  SPACE_USER_SESSIONS_COLUMN_CONFIG,
  SPACE_USER_SESSIONS_COLUMNS_STORAGE_KEY,
} from "./constants";

const useSpaceDetailsUserSessionsTableStore = createTableStore({
  storageKey: SPACE_USER_SESSIONS_COLUMNS_STORAGE_KEY,
  config: SPACE_USER_SESSIONS_COLUMN_CONFIG,
});

export default useSpaceDetailsUserSessionsTableStore;
